// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3JLG-","headingWrapper":"Card_headingWrapper__3E77G","heading":"Card_heading__14oP7"};